import React, { ReactNode, useState } from "react";
import { Dropdown, FormControl } from "react-bootstrap";

type MenuProps = {
    className?: string;
    children?: ReactNode;
    dropdown?: boolean;
    filterable?: boolean;
    nothingFoundMessage?: string;
    searchMessage?: string;
    [x: string]: any;
};

export const Menu = ({
    className,
    children,
    dropdown = true,
    filterable = false,
    nothingFoundMessage = "Nothing Found",
    searchMessage = "Search",
    ...props
}: MenuProps) => {
    const [value, setValue] = useState("");
    if (dropdown === undefined || dropdown === null) dropdown = true;
    if (dropdown) {
        var dropdownProps = {
            className: !className ? "shadow-4 border-0" : className,
        };
        if (!filterable) {
            return <Dropdown.Menu {...dropdownProps}>{children}</Dropdown.Menu>;
        } else {
            var v = value ? value.toLowerCase() : null;
            var items = React.Children.toArray(children).filter((x) => isMatch(x, v));
            return (
                <Dropdown.Menu {...dropdownProps} {...props}>
                    <FormControl
                        autoFocus
                        className="mx-3 my-2 w-auto"
                        placeholder={searchMessage}
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                    />
                    {items.length == 0 && (
                        <div className="p-3" style={{ opacity: 0.5 }}>
                            {nothingFoundMessage}
                        </div>
                    )}
                    {items}
                </Dropdown.Menu>
            );
        }
    } else {
        return <></>;
    }
};

export const MenuHeader = ({ ...props }) => {
    return <Dropdown.Header {...props}>{props.children}</Dropdown.Header>;
};

export const MenuDivider = () => {
    return <div className="dropdown-divider"></div>;
};

export const MenuItem = ({ ...props }) => {
    return <Dropdown.Item {...props}>{props.children}</Dropdown.Item>;
};

export const SubMenu = ({ menu, className = "", ...props }) => {
    var cn = className + (className ? " " : "") + "dropdown-item";
    return (
        <Dropdown as="div" {...props} className="dropdown-submenu">
            <Dropdown.Toggle as="button" className={cn}>
                {props.children}
            </Dropdown.Toggle>
            {menu}
        </Dropdown>
    );
};

const isMatch = (elem, value) => {
    var children = elem.props.children;
    if (!children || !value) return true;
    if (typeof children === "string") {
        return children.toLowerCase().indexOf(value) >= 0;
    }
    return React.Children.toArray(children).filter((child) => isMatch(child, value));
};
